<template>
  <div class="confirmInformation">
    <!-- 上半部分 -->
    <van-form validate-first @submit="next">
      <div class="formation-all">
        <div class="formation-basic">基本信息</div>
        <div class="formation-small">请确核对各项资料完整、准确</div>
      </div>
      <van-field
        :value="formData.userName"
        label="真实姓名"
        placeholder="用户名"
        readonly
        :rules="[{ required: true}]"
      />
      <van-field
        :value="formData.idNo"
        label="身份证号码"
        readonly
        placeholder="身份证号码"
        :rules="[{ required: true,}]"
      />
      <van-field
        readonly
        label="民族"
        placeholder="选择民族 >"
        :required="true"
        v-model="formData.nationStr"
        @click="onNationClick"
        :rules="[{ required: true, message:'请选择民族' }]"
      />
     
      <van-popup v-model="isNationPopupShow" round position="bottom">
         <van-picker 
          show-toolbar
          v-model="formData.nation"
          title="选择民族"
          :columns="nationList"   
          @cancel="isNationPopupShow = false"
          @confirm="onNationConfirm"
          />
      </van-popup>
      <van-field      
        :value="formData.idCardBeginTime"
        :required="true"
        label="身份证有效期"
        placeholder="开始时间 >"
        @click="idCardStartShow = true"
      />

      <van-popup v-model="idCardStartShow" position="bottom">
        <van-datetime-picker
          :value="formData.idCardBeginTime"
          type="date"
          title="开始时间"
          :min-date="minDate"
          :max-date="maxDate"
          :rules="[{ required: true, message:'请选择开始时间' }]"
          @cancel="idCardStartShow = false"
          @confirm="onIdCardStartConfirm"
      /></van-popup>

      <van-field
        :value="formData.idCardEndTime"
        label=""
        placeholder="截止时间 >"
        @click="idCardEndShow = true"
      />

      <van-popup v-model="idCardEndShow" position="bottom">
      <van-datetime-picker
          :value="formData.idCardEndTime"
          type="date"
          title="截止时间"
          :rules="[{ required: true, message:'请选择截止日期' }]"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="idCardEndShow = false"
          @confirm="onIdCardEndConfirm"
      /></van-popup>

      <!-- 下半部分 -->
      <div class="formation-all">
        <div class="formation-basic">补充信息</div>
        <div class="formation-small">请确核对各项资料完整、准确</div>
      </div>

      <van-field
        v-model="formData.profession"
        label="职业"
        readonly
      />

      <van-field
        v-model="formData.employer"
        label="工作单位"
        readonly
      />

      <van-field
        readonly
        clickable
        :value="formData.residentAreaName"
        label="常驻地区"
        :rules="[{ required: true, message:'请选择常驻地区' }]"
        placeholder="选择城市 >"
        @click="onAddressClick"
      />
      <van-popup v-model="isAddressPopupShow" round position="bottom">
        <van-cascader
          v-model="formData.residentArea"
          title="请选择所在地区"
          :rules="[{ required: true, message:'请选择所在地区' }]"
          :options="getCitys"
          active-color="#1989fa"
          @close="isAddressPopupShow=false"
          @finish="residentAreaNameOnFinish"
        />
      </van-popup>

      <van-field
        v-model="formData.addressDetails"
        name="详细地址"
        label="详细地址"
        placeholder="详细地址"
        
        :rules="[{ required: true ,message:'请输入详细地址' }]"
      />
      <div style="margin-bottom: 100x">
        <van-button  block type="info" native-type="submit" class="next"
          >下一步</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import dayjs from "dayjs";
import http from "../../../api/index.js";
import config from "../../../utils/config";
import citys from '../data/citys';
import nations from '../data/nations'
export default {
  props: {
    authInfoVo: Object,
  },
  data() {
    return {
      formData: {
        // 基本信息
        nation: "", // 民族
        nationStr: "",
        userName: "",
        idNo: "",
        idCardBeginTime: "",
        idCardEndTime: "",
        employer: "自由职业者",
        residentArea: "",
        residentAreaName: "",
        addressDetails: "",
        profession:"自由职业者",
        residentAreaNameStr: "",
      },
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2077, 12, 31),
      idCardStartShow: false,
      idCardEndShow: false,
      isAddressPopupShow: false,
      isNationPopupShow: false,
      nationList:[],
    };
  },
  computed: {
		getCitys() {
			return citys;
		},
    // getNations(){
    //   return nations
    // }
    // getIdNoStr() {
    //   if (this.formData.idNo) {
    //     return `${this.formData.idNo.slice(0, 6)}********${this.formData.idNo.slice(14)}`
    //   }   
    // }
	},
  watch: {
    authInfoVo: {
      handler(old, cur) {
        const {idNo, userName, idCardEndTime, idCardBeginTime} = this.authInfoVo
        this.formData.userName =userName;
        this.formData.idNo = idNo;
        this.formData.idCardBeginTime = idCardBeginTime;
        this.formData.idCardEndTime = idCardEndTime;
      }, 
      deep: true,
      immediate: true,
    } 
  },
  beforeUpdate() {
    console.log('---->', this.authInfoVo)
  },
  mounted() {
    this.fetchNationList();    
  },
  methods: {
    onNationConfirm(data) {
      this.formData.nationStr = data.text;
      this.formData.nation = data.code;
      this.isNationPopupShow = false;
    },
    fetchNationList(){
      http.post(config.getNation,).then(({code,data})=>{
          this.nationList = data ? data.map(item=>{
          item.text=item.name;
          item.value=item.code;
          return item   
          }) : []
    }) 
    },
    residentAreaNameOnFinish({ selectedOptions }) {
      console.log(selectedOptions)
      this.isAddressPopupShow = false;
      this.formData.residentAreaName = selectedOptions.map((item) => item.text).join();
      const area = selectedOptions[selectedOptions.length - 1];
      this.formData.residentAreaNameStr = area.text;
      this.formData.residentArea = area.value
    },
    next(){ 
      this.$emit("onNextStep", 2, this.formData)
    },
    // 身份证有效期
    onIdCardStartConfirm(date) {
      const {idCardEndTime } = this.formData;
      if (dayjs(date) > dayjs()) {
        this.$toast.fail('不能大于当前时间');
        return
      }
      if(idCardEndTime && dayjs(date) >= dayjs(idCardEndTime)) {
        this.$toast.fail('身份证起始时间要小于截止时间');
        return 
      }
      this.formData.idCardBeginTime = dayjs(date).format("YYYY-MM-DD");
      this.formData.idCardEndTime = dayjs(date).add(20, 'year').format("YYYY-MM-DD");
      this.idCardStartShow = false;
    },
    onIdCardEndConfirm(date) {
      const {idCardStartTime } = this.formData;
      if (dayjs(date) < dayjs()) {
        this.$toast.fail('不能小于当前时间');
        return
      }
      if(idCardStartTime && dayjs(idCardStartTime) >= dayjs(date)  ) {
        this.$toast.fail('身份证截止时间要大于起始时间');
        return 
      }
      this.formData.idCardEndTime = dayjs(date).format("YYYY-MM-DD");
      this.idCardEndShow = false;
    },
    // vant 地区选择
    onAddressClick() {
      this.isAddressPopupShow = true;
    },
    onNationClick(){
      this.isNationPopupShow = true;
    },
    onConfirmAddress(a, b) {
      this.addressName = a.join(",");
      this.isAddressPopupShow = false;
      console.log(a, b); // ["浙江", "杭州", "余杭区"]   [0, 0, 1]
    },
  },
};
</script>
<style>
.van-cell{
  padding: 32px 32px;
}
.confirmInformation .van-field__control {
  text-align: right;
}
.confirmInformation .van-field--error .van-field__control, .van-field--error .van-field__control::placeholder{
  color: #CBCCCF;
}
.confirmInformation .van-field__error-message{
  text-align: right;
}
</style>
<style lang="less" scoped>
.confirmInformation {
  padding-bottom: 90px;
  .formation-all {
    height: 157px;
    border-bottom: 1px solid #ececec;
    margin-left: 30px;
    text-align: left;
    .formation-basic {
      font-size: 32px;
      color: #222222;
      padding-top: 30px;
    }
    .formation-small {
      font-size: 24px;
      color: #999999;
      margin-top: 10px;
    }
  }
  .next{
    position: fixed;
    bottom: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/commonInfo/components/baseInfo.vue